import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'admin-on-rest';
import { getFormValues, Field, change as onChange } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import {
  Card,
  CardHeader,
  List,
  ListItem,
  Divider,
} from 'material-ui';
import ToggleInput from './ToggleInput';


const styles = {
  wrapper: { padding: '1em 0' },
  tabContent: { padding: '0.3em 1em 1em 1em' },
  headline: {
    fontSize: 24,
    paddingTop: 16,
    marginBottom: 12,
    fontWeight: 400,
  },
  permissionWrapper: {
    display: 'flex',
    flexDirection: 'row',
  },
  indicator: {
    color: '#960000',
    fontSize: '0.9em',
  },
  indicatorChecked: {
    color: '#29603B',
    fontWeight: 'bold',
    fontSize: '0.9em',
  },
};

const Indicator = ({ checked, children }) => (
  <div style={checked ? styles.indicatorChecked : styles.indicator}>{children}</div>
);
const PermissionIndicators = ({ permissions, hidden }) => (
  <div style={styles.permissionWrapper}>
    <Indicator checked={hidden}>HIDDEN</Indicator>
    <strong>&nbsp;-&nbsp;</strong>
    <Indicator checked={permissions && permissions.show}>SHOW</Indicator>
    <strong>&nbsp;-&nbsp;</strong>
    <Indicator checked={permissions && permissions.create}>CREATE</Indicator>
    <strong>&nbsp;-&nbsp;</strong>
    <Indicator checked={permissions && permissions.list}>LIST</Indicator>
    <strong>&nbsp;-&nbsp;</strong>
    <Indicator checked={permissions && permissions.edit}>EDIT</Indicator>
    <strong>&nbsp;-&nbsp;</strong>
    <Indicator checked={permissions && permissions.delete}>DELETE</Indicator>
  </div>
);

// eslint-disable-next-line no-shadow
class ResourcePermissionInput extends React.Component {
  componentWillMount = () => {
    const { change, record, source, resources } = this.props;
    const newRecord = record;
    if (!record.resources) {
      newRecord.resources = {};
    }
    const newRecordResources = record.resources;

    resources.forEach((resource) => {
      if (!record.resources[resource.name]) {
        newRecordResources[resource.name] = { delete: false, edit: false, list: false, create: false };
      }
    });
    change('record-form', source, newRecordResources);
  };

  // shouldComponentUpdate = (nextProps) => this.props.resources.length < nextProps.resources.length;

  render() {
    // eslint-disable-next-line no-shadow
    const { source, translate, record, resource, resources } = this.props;

    return (
      <div style={styles.wrapper}>
        <Card>
          <CardHeader title={translate(`resources.${resource}.fields.${source}`)} />
          <Divider />
          <List>
            {resources.map(({ name }) => (
              <ListItem
                primaryText={translate(`resources.${name}.name`, { smart_count: 1 })}
                secondaryText={record.resources && (
                  <PermissionIndicators
                    hidden={record.resources && record.resources[name] && record.resources[name].hidden}
                    permissions={record.resources && record.resources[name]}
                  />
                )}
                primaryTogglesNestedList
                nestedItems={[
                  // <Field
                  //   key={`${name}-permission-name`}
                  //   name={`${source}[${name}].name`}
                  //   component={(props) => <input style={{ display: 'none' }} {...props} />}
                  //   type="text"
                  // />,
                  <Field
                    key={`${name}-hidden`}
                    name={`${source}[${name}].hidden`}
                    component={(props) => (
                      <ListItem
                        primaryText="Hidden in menu"
                        rightToggle={<ToggleInput {...props} />}
                      />
                    )}
                    type="text"
                  />,
                  <Field
                    key={`${name}-permission-show`}
                    name={`${source}[${name}].show`}
                    component={(props) => (
                      <ListItem
                        primaryText="SHOW"
                        rightToggle={<ToggleInput {...props} />}
                      />
                    )}
                    type="text"
                  />,
                  <Field
                    key={`${name}-permission-create`}
                    name={`${source}[${name}].create`}
                    component={(props) => (
                      <ListItem
                        primaryText="CREATE"
                        rightToggle={<ToggleInput {...props} />}
                      />
                    )}
                    type="text"
                  />,
                  <Field
                    key={`${name}-permission-list`}
                    name={`${source}[${name}].list`}
                    component={(props) => (
                      <ListItem
                        primaryText="LIST"
                        rightToggle={<ToggleInput {...props} />}
                      />
                    )}
                    type="text"
                  />,
                  <Field
                    key={`${name}-permission-edit`}
                    name={`${source}[${name}].edit`}
                    component={(props) => (
                      <ListItem
                        primaryText="EDIT"
                        rightToggle={<ToggleInput {...props} />}
                      />
                    )}
                    type="text"
                  />,
                  <Field
                    key={`${name}-permission-delete`}
                    name={`${source}[${name}].delete`}
                    component={(props) => (
                      <ListItem
                        primaryText="DELETE"
                        rightToggle={<ToggleInput {...props} />}
                      />
                    )}
                    type="text"
                  />,
                ]}
              />
            ))}
          </List>
        </Card>
      </div>
    );
  }
}

ResourcePermissionInput.propTypes = {
  source: PropTypes.string,
};

ResourcePermissionInput.defaultProps = {
  record: { resources: {} },
};

const selector = getFormValues('record-form');

const enhance = compose(
  translate
);

export default connect((state) => ({ record: selector(state) }), { change: onChange })(enhance(ResourcePermissionInput));
